// extracted by mini-css-extract-plugin
export default {"bref":"index_bref_mULIZ","brefHeadTitle":"index_brefHeadTitle_9N77L","brefHeadMore":"index_brefHeadMore_wT0pO"};